import { Modal, Table } from "../../../../components";
import { useAdminStore } from "../../../../store/adminStore";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { motion } from "framer-motion";
import ViewMap from "../../../../components/ViewMap";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import {
  handlerCambiarEstado,
  handlerCancelar,
  handlerFinalizarActa,
} from "../../../../handlers/actas.handler";
import { usePodadoresStore } from "../../../../store/podadoresStore";
import { tableDataPodadores } from "../tableDataPodadores";
import useWindowSize from "../../../../hooks/useWindowSize";
import ModalAsignarPodadores from "./ModalAsignarPodadores";
import { useFormActaStore } from "../../../../store/formActaStore";
import StarRating from "../../../../components/StarRating";
import Loading from "../../../../components/Loading";

const ModalCancelarActa = ({ actaId }) => {
  const { modals, handlerModal, loads } = useGeneralAppStore();
  const { podadores, podadoresSelect, setPodadoresSelect } = usePodadoresStore();
  const { width } = useWindowSize();
  const { defaultValues } = useFormActaStore();

  const [ratings, setRatings] = useState({});
  /* const [podadoresSelect, setPodadoresSelect] = useState([]) */

  const handleRating = (podadorId, value) => {
    setRatings((prev) => ({ ...prev, [podadorId]: value }));
  };

  useEffect(() => {
    return () => {
      handlerModal({ modal: false, modalName: "cancelar_acta" });
    };
  }, []);
  // useEffect(() => {
  //     if (defaultValues.podadores.length > 0) {
  //         setPodadoresSelect(defaultValues.podadores)
  //     }

  //     return () => {
  //         setPodadoresSelect([])
  //     }
  // }, [])

  return (
    <>
      <Modal
        size="md"
        show={modals.includes("cancelar_acta")}
        onHide={() => handlerModal({ modal: false, modalName: "cancelar_acta" })}
        title={() => "Cancelar acta"}
      >
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="w-100 position-relative"
        >
          {loads.includes("cambiar_estado") && (
            <div
              className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
              style={{ zIndex: "9", backgroundColor: "rgba(255,255,255,0.8)" }}
            >
              <Loading sizeIcono="50px" sizeLoad="70px" font="14px" />
            </div>
          )}
          <Alert variant="danger">
            Desea <b>rechazar</b> el acta?
          </Alert>
          <div>
            <hr />
            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  handlerModal({ modal: false, modalName: "cancelar_acta" });
                }}
              >
                Rechazar
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => handlerCancelar(actaId)}>
                Confirmar
              </button>
            </div>
          </div>
        </motion.div>
        {modals.includes("asignar_podadores") && <ModalAsignarPodadores />}
      </Modal>
    </>
  );
};
export default ModalCancelarActa;
